/*
 * @Author: your name
 * @Date: 2020-08-11 09:53:42
 * @LastEditTime: 2020-08-11 12:02:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cimdr2018/src/main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'

import store from '@/store/index.js'

import extendFn from '@/plugin/extendFn'
Vue.use(extendFn);

import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

import mVueUtils from '@/plugin/mVueUtils'
Vue.use(mVueUtils);

import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);

import '../static/css/Common.css';


import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 通过插件的形式挂载

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') == 'en' ? 'en-US' : 'zh-CN',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('../static/js/zh'),   // 中文语言包
    'en-US': require('../static/js/en')    // 英文语言包
  }
})


Vue.config.productionTip = false

let px2rem = function () {
  document.addEventListener('DOMContentLoaded', function () {
    var html = document.documentElement;
    var windowWidth = html.clientWidth;
    html.style.fontSize = windowWidth / 7.5 + 'px';
    // console.log(windowWidth)
  }, false);
};
px2rem();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js